export const DOWNLOAD_BANNER_VISIBLE = {
  YES: "true",
  NO: "false",
};

export const DOWNLOAD_APP_BANNER_COOKIE = "badi_banner_download_app";
